export default __webpack_public_path__ + "static/media/agustin14.5fdce656.png";